import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageFive from "./pages/HomePageFive";
import AddUserPage from "./pages/AddUserPage";
import ErrorPage from "./pages/ErrorPage";
import AssignRolePage from "./pages/AssignRolePage";
import RoleAccessPage from "./pages/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import EditTutorPage from "./pages/EditTutorPage";
import GuestListPage from "./pages/GuestListPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import StudentListPage from "./pages/StudentListPage";
import TutorListPage from "./pages/TutorListPage";

import Batcheslist from "./pages/Batches/Batcheslist";
import AddBatch from "./pages/Batches/BatchesCreationPage";
import EditBatch from "./pages/Batches/EditBatches";

import MembershipPlan from "./pages/Membership/Membershiplist";
import AddMembershipPlan from "./pages/Membership/MembershipCreationPage";
import EditMembershipPlan from "./pages/Membership/EditMembershipPage";
import SubscriptionPlan from "./pages/Subscriptions/SubcriptionPage";
import AddSubscriptionPlan from "./pages/Subscriptions/SubscriptionCreationPage";
import EditSubscriptionPlan from "./pages/Subscriptions/EditSubscriptions";
import DepartmentPage from "./pages/DepartmentPage";
import AddDepartmenmtpage from "./pages/AddDepartmentPage";
import CourseCategoryPage from "./pages/Levellistpage";
import CoursesPage from "./pages/CoursesPage";
import AddCourseCategory from "./pages/AddCourseCategoryPage";
import EditDepartment from "./pages/EditDepartment";
import EditCourseCategory from "./pages/EditCourseCategory";
import AddCourse from "./pages/AddCoursePage";
import EditCourse from "./pages/EditCourse";
import EnquiryLists from "./pages/EnquiryPage"
import LessonsPage from "./pages/LessonsPage";
import EnquiryPage from "./pages/EnquiryPage";
import EditUsers from "./pages/EditUsersPage";
import AddStudentPage from "./pages/AddStudentPage";
import EditStudent from "./pages/EditStudentpage";
import AddTutorpage from "./pages/AddTutor";
import AssignCoursesPage from "./pages/AssignCoursePage";
import AddAssignCoursePage from "./pages/AssignCourseAdd";
import EditAssignCoursePage from "./pages/EditAssignCoursePage";
import ChapterPage from "./pages/Chapter/ChapterPage";
import AddChapter from "./pages/Chapter/ChapterAddPage";
import ChapterEdit from "./pages/Chapter/EditChapter";
import UnitListPage from "./pages/Unit/UnitList";
import unitAddPage from "./pages/Unit/UnitAddPage";
import UnitEditPage from "./pages/Unit/EditUnit";
import UnitViewPage from "./pages/Unit/ViewUnitPage";
import EditUnitPlans from "./pages/Unit/EditUnitPlans";
import TraderListPage from "./pages/TraderListPage";
import AddGuest from "./pages/AddGuestPage";
import AddTraderPage from "./pages/AddTraderPage";
import EditGuestPage from "./pages/EditGuestPage";
import EditTraderPage from "./pages/EditTraderPage";
import CalenderPage from "./pages/CalenederPage"
import CommunityList from "./pages/FreeCommunityListPage";
import AddCommunityPage from "./pages/AddFreeCommunityPage";
import EditCommunityPage from "./pages/EditFreeCommunityPage";
import HighlightListPage from "./pages/HighlightsListPage";
import EditHighlightPage from "./pages/EditHighlightPage";
import AddHighlightPage from "./pages/AddHighlightPage";
import CourseCommunityListPage from "./pages/CourseCommunityListPage";
import AddCourseCommunityLayer from "./components/AddCourseCommunityLayer";
import AddCourseCommunityPage from "./pages/AddCourseCommunityPage";
import EditCourseCommunityPage from "./pages/EditCourseCommunityPage";
import FreeVideoListPage from "./pages/FreeVideoListPage";
import AddFreeVideoPage from "./pages/AddFreeVideoPage";
import EditFreeVideoPage from "./pages/EditFreeVideoPage";
import ViewCoursePage from "./pages/ViewCoursePage";
import NoticeBoardListPage from "./pages/NoticeBoardListPage";
import NoticeBoardCategoryListPage from "./pages/NoticeboardCategoryListPage";
import AddNoticeboardCategoryPage from "./pages/AddNoticeboardCategoryPage";
import EditNoticeboardCategoryPage from "./pages/EditNoticeboardCategoryPage";
import AddNoticeboardPage from "./pages/AddNoticeboardPage";
import EditNoticeboardPage from "./pages/EditNoticeboardPage";
import CoursePaymentListPage from "./pages/CoursePaymentPage";
import MembershipPaymentListPage from "./pages/MembershipPaymentPage";
import SubscriptionPaymentListPage from "./pages/SubscriptionPaymentPage";
import PromtionListPage from "./pages/PromotionListPage";
import EditPromotionPage from "./pages/EditPromotionPage";
import AddPromotionPage from "./pages/AddPromotionPage";
import EnRolledCoursePage from "./pages/EnRolledCoursePage";

import Referrals from "./pages/Referral/ReferralPage";
import AddReferrals from "./pages/Referral/AddReferal";
import EditReferrals from "./pages/Referral/EditReferral";
// import AddCoursePage from "./pages/AddCoursePage";
// import AddLessonPage from "./pages/AddLessonsPage";
import UnitVerification from "./pages/VerificationPage/CompletedUnits"
import EditZoom from "./pages/Zoom/EditZoom";
import AddZoom from "./pages/Zoom/AddZoom";
import ZoomList from "./pages/Zoom/ZoomList";
import ChatListPage from "./pages/ChatListPage";
import ChatViewPage from "./pages/ChatViewPage";
import PaypalButton from "./pages/Paypal/PaypalButton";
import TeamList from "./pages/TeamListPage";
import AddTeamPage from "./pages/AddTeamPage";
import EditTeamPage from "./pages/EditTeamPage";
import DirectorList from "./pages/DirectorListPage";
import StudentAssessmentList from "./pages/StudentAssessmentListPage";
import ViewStudentAssessmentpage from "./pages/ViewStudentAssessmentpage";

const routes = [
  { route: "/", component: SignInPage },
  // { route: "/paypal/:token", component: PaypalButton },
  { route: "/dashboard", component: HomePageFive },
  
  {
    route: "/student-list",
    component: StudentListPage,
    permissionName: "student.index",
  },
  {
    route: "/student-create",
    component: AddStudentPage,
    permissionName: "student.create",
  },
  {
    route: "/view-student",
    component: EditStudent,
    permissionName: "student.edit"
  },
  {
    route: "/guest-list",
    component: GuestListPage,
    permissionName: "guests.index"
  },
  // trader
  {
    route: "/trader-list",
    component: TraderListPage,
    permissionName: "traders.index",
  },
  {
    route: "/add-trader",
    component: AddTraderPage,
    permissionName: "traders.create",
  },
  {
    route: "/edit-trader",
    component: EditTraderPage,
    permissionName: "traders.edit",
  },

  { route: "/role-access", component: RoleAccessPage, permissionName: "role.index" },
  { route: "/assign-role", component: AssignRolePage, permissionName: "assignRole.index" },

  {
    route: "/batch-list",
    component: Batcheslist,
    permissionName: "batch.index",
  },
  {
    route: "/add-batch",
    component: AddBatch,
    permissionName: "batch.create",
  },

  {
    route: "/editbatch",
    component: EditBatch,
    permissionName: "batch.edit",
  },

  {
    route: "/department-list",
    component: DepartmentPage,
    permissionName: "department.index",
  },
  {
    route: "/add-department-list",
    component: AddDepartmenmtpage,
    permissionName: "department.create"
  },
  {
    route: "/edit-department",
    component: EditDepartment,
    permissionName: "department.edit",
  },
  {
    route: "/level-list",
    component: CourseCategoryPage,
    permissionName: "level.index",
  },
  {
    route: "/add-level",
    component: AddCourseCategory,
    permissionName: "level.create",
  },
  {
    route: "/edit-level",
    component: EditCourseCategory,
    permissionName: "level.edit",
  },
  {
    route: "/courses-list",
    component: CoursesPage,
    permissionName: "course.index",
  },

  {
    route: "/add-course",
    component: AddCourse,
    permissionName: "course.create",
  },
  {
    route: "/edit-course",
    component: EditCourse,
    permissionName: "course.edit",
  },
  {
    route: "/view-course",
    component: ViewCoursePage,
    permissionName: "course.view",
  },
  {
    route: "/chapter-list",
    component: ChapterPage,
    permissionName: "chapters.index",
  },

  {
    route: "/add-chapter",
    component: AddChapter,
    permissionName: "chapters.create",
  },
  {
    route: "/edit-chapter",
    component: ChapterEdit,
    permissionName: "chapters.edit",
  },
  {
    route: "/unit-list",
    component: UnitListPage,
    permissionName: "units.index",
  },

  {
    route: "/add-unit",
    component: unitAddPage,
    permissionName: "units.create",
  },
  {
    route: "/edit-unit/:id",
    component: UnitEditPage,
    permissionName: "units.edit",
  },
  {
    route: "/unitplans-edit/:id",
    component: EditUnitPlans,
    permissionName: "units.viewEdit",
  },
  {
    route: "/unit-view/:id",
    component: UnitViewPage,
    permissionName: "units.view",
  },

  {
    route: "/tutor-list",
    component: TutorListPage,
    permissionName: "tutor.index",
  },
  {
    route: "/tutor-add",
    component: AddTutorpage,
    permissionName: "tutor.create",
  },
  {
    route: "/tutor-view",
    component: EditTutorPage,
    permissionName: "tutor.edit",
  },

  {
    route: "/assigncourse-list",
    component: AssignCoursesPage,
    permissionName: "assignCourse.index",
  },

  {
    route: "/assigncourse-add",
    component: AddAssignCoursePage,
    permissionName: "assignCourse.create",
  },

  {
    route: "/assigncourse-edit",
    component: EditAssignCoursePage,
    permissionName: "assignCourse.edit",
  },

  {
    route: "/timetable-view",
    component: CalenderPage,
    permissionName: "timetable.view",
  },
  {
    route: "/community-list",
    component: CommunityList,
    permissionName: "freecommunities.index",
  },
  {
    route: "/add-community",
    component: AddCommunityPage,
    permissionName: "freecommunities.create",
  },
  {
    route: "/edit-community",
    component: EditCommunityPage,
    permissionName: "freecommunities.edit",
  },
  {
    route: "/course-community-list",
    component: CourseCommunityListPage,
    permissionName: "coursecommunities.index",
  },
  {
    route: "/add-course-community",
    component: AddCourseCommunityPage,
    permissionName: "coursecommunities.create",
  },
  {
    route: "/edit-course-community",
    component: EditCourseCommunityPage,
    permissionName: "coursecommunities.edit",
  },
  {
    route: "/highlight-list",
    component: HighlightListPage,
    permissionName: "highlights.index",
  },
  {
    route: "/add-highlight",
    component: AddHighlightPage,
    permissionName: "highlights.create",
  },
  {
    route: "/edit-highlight",
    component: EditHighlightPage,
    permissionName: "highlights.edit",
  },
  {
    route: "/freevideo-list",
    component: FreeVideoListPage,
    permissionName: "freevideos.index",
  },
  {
    route: "/add-freevideo",
    component: AddFreeVideoPage,
    permissionName: "freevideos.create",
  },
  {
    route: "/edit-freevideo",
    component: EditFreeVideoPage,
    permissionName: "freevideos.edit",
  },

  //Membership plans
  {
    route: "/membership-list",
    component: MembershipPlan,
    permissionName: "membership.index",
  },

  {
    route: "/add-membership",
    component: AddMembershipPlan,
    permissionName: "membership.create",
  },

  {
    route: "/edit-membership",
    component: EditMembershipPlan,
    permissionName: "membership.edit",
  },

  //Suibcription plans
  {
    route: "/subscription-list",
    component: SubscriptionPlan,
    permissionName: "subscription.index",
  },

  {
    route: "/add-subscription",
    component: AddSubscriptionPlan,
    permissionName: "subscription.create",
  },

  {
    route: "/edit-subscription",
    component: EditSubscriptionPlan,
    permissionName: "subscription.edit",
  },

  {
    route: "/noticeboardCategory-list",
    component: NoticeBoardCategoryListPage,
    permissionName: "membership.index",
  },

  {
    route: "/add-noticeboardCategory",
    component: AddNoticeboardCategoryPage,
    permissionName: "membership.index",
  },

  {
    route: "/edit-noticeboardCategory",
    component: EditNoticeboardCategoryPage,
    permissionName: "membership.index",
  },

  {
    route: "/noticeboard-list",
    component: NoticeBoardListPage,
    permissionName: "noticeboard.index",
  },

  {
    route: "/add-noticeboard",
    component: AddNoticeboardPage,
    permissionName: "noticeboard.create",
  },

  {
    route: "/edit-noticeboard",
    component: EditNoticeboardPage,
    permissionName: "noticeboard.edit",
  },
  // Verification
  {
    route: "/verification-list/:batchId",
    component: UnitVerification,
    permissionName: "courseverification.index",
  },
  // REferrals
  {
    route: "/referrals-list",
    component: Referrals,
    permissionName: "freevideos.index",
  },

  {
    route: "/add-referral",
    component: AddReferrals,
    permissionName: "freevideos.create",
  },

  {
    route: "/edit-referral",
    component: EditReferrals,
    permissionName: "freevideos.edit",
  },
  {
    route: "/zoom-list",
    component: ZoomList,
    permissionName: "student.index"
  },

  {
    route: "/add-zoom",
    component: AddZoom,
    permissionName: "courseverification.index",
  },
  {
    route: "/edit-zoom",
    component: EditZoom,
    permissionName: "courseverification.index",
    
  },
  {
    route: "/course-payments",
    component: CoursePaymentListPage,
    permissionName: "freevideos.index"
  },
  {
    route: "/membership-payments",
    component: MembershipPaymentListPage,
    permissionName: "freevideos.index",
  },
  {
    route: "/subscription-payments",
    component: SubscriptionPaymentListPage,
    permissionName: "freevideos.index",
  },
  {
    route: "/chat-list",
    component: ChatListPage,
    permissionName: "student.index",
  },
  {
    route: "/chat-view",
    component: ChatViewPage, 
    permissionName: "student.index",
  },
  // Protion
  {
    route: "/promotion-list",
    component: PromtionListPage,
    permissionName: "promotion.index",
  },
  {
    route: "/add-promotion",
    component: AddPromotionPage,
    permissionName: "promotion.create",
  },
  {
    route: "/edit-promotion",
    component: EditPromotionPage,
    permissionName: "promotion.edit",
  },
  {
    route: "/enrolledcourse-list",
    component: EnRolledCoursePage,
    permissionName: "assignCourse.index",
  },
  // directors
  {
    route: "/directors-list",
    component: DirectorList,
    permissionName: "highlights.index",
  },
  {
    route: "/add-director",
    component: AddPromotionPage,
    permissionName: "highlights.create",
  },
  {
    route: "/edit-director",
    component: EditPromotionPage,
    permissionName: "highlights.edit",
  },
  //team members
  {
    route: "/team-list",
    component: TeamList,
    permissionName: "highlights.index",
  },
  {
    route: "/add-team",
    component: AddTeamPage,
    permissionName: "highlights.create",
  },
  {
    route: "/edit-team",
    component: EditTeamPage,
    permissionName: "highlights.edit",
  },
  // Assessment 
  {
    route: "/student-assessment-list",
    component: StudentAssessmentList,
    permissionName: "assessment.index",
  },
  {
    route: "/view-student-ap",
    component: ViewStudentAssessmentpage,
    permissionName: "assessment.view"
  },
  // Assessment 
  {
    route: "/trader-portfolio-list",
    component: TeamList,
    permissionName: "portfolio.index",
  },

  { route: "*", component: ErrorPage, permissionName: null },
  // <Route exact path="*" element={<ErrorPage />} />,
];

export default routes;
